var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[this.color, 'pseudo-button', 'sharing-button']},[_c('span',{class:[ 'shine', this.type === 'download' ? 'shine-1' : 'shine-2']}),_c('div',[_vm._v(_vm._s(this.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }